import React from 'react';

interface TemplateWarningBannerProps {
  text: string;
}

const TemplateWarningBanner: React.FC<TemplateWarningBannerProps> = ({ text }) => {
  const bannerStyle: React.CSSProperties = {
    backgroundColor: '#ECE1FF',
    border: '1px solid #8E53F7',
    borderRadius: '12px',
    padding: '14px 20px 12px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
  };

  const textStyle: React.CSSProperties = {
    fontFamily: 'Segoe UI, sans-serif',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '16px',
    color: '#8E53F7',
    verticalAlign: 'middle',
    letterSpacing: '0%',
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  return (
    <div style={bannerStyle}>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 13.75C8.80189 13.7474 8.61263 13.6676 8.47253 13.5275C8.33244 13.3874 8.25259 13.1981 8.25 13V8C8.25 7.80109 8.32902 7.61032 8.46967 7.46967C8.61032 7.32902 8.80109 7.25 9 7.25C9.19891 7.25 9.38968 7.32902 9.53033 7.46967C9.67098 7.61032 9.75 7.80109 9.75 8V13C9.74741 13.1981 9.66756 13.3874 9.52747 13.5275C9.38737 13.6676 9.19811 13.7474 9 13.75Z" fill="#8E53F7" />
        <path d="M9 6.25C8.80189 6.24741 8.61263 6.16756 8.47253 6.02747C8.33244 5.88737 8.25259 5.69811 8.25 5.5V5C8.25 4.80109 8.32902 4.61032 8.46967 4.46967C8.61032 4.32902 8.80109 4.25 9 4.25C9.19891 4.25 9.38968 4.32902 9.53033 4.46967C9.67098 4.61032 9.75 4.80109 9.75 5V5.5C9.74741 5.69811 9.66756 5.88737 9.52747 6.02747C9.38737 6.16756 9.19811 6.24741 9 6.25Z" fill="#8E53F7" />
        <path d="M9 18C7.21997 18 5.47991 17.4722 3.99987 16.4832C2.51983 15.4943 1.36628 14.0887 0.685088 12.4442C0.00389951 10.7996 -0.17433 8.99002 0.172937 7.24419C0.520203 5.49836 1.37737 3.89472 2.63604 2.63604C3.89472 1.37737 5.49836 0.520203 7.24419 0.172937C8.99002 -0.17433 10.7996 0.00389951 12.4442 0.685088C14.0887 1.36628 15.4943 2.51983 16.4832 3.99987C17.4722 5.47991 18 7.21997 18 9C18 11.387 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.387 18 9 18ZM9 1.5C7.51664 1.5 6.0666 1.93987 4.83323 2.76398C3.59986 3.58809 2.63856 4.75943 2.07091 6.12988C1.50325 7.50032 1.35473 9.00832 1.64411 10.4632C1.9335 11.918 2.64781 13.2544 3.6967 14.3033C4.7456 15.3522 6.08197 16.0665 7.53683 16.3559C8.99168 16.6453 10.4997 16.4968 11.8701 15.9291C13.2406 15.3614 14.4119 14.4001 15.236 13.1668C16.0601 11.9334 16.5 10.4834 16.5 9C16.5 7.01088 15.7098 5.10323 14.3033 3.6967C12.8968 2.29018 10.9891 1.5 9 1.5Z" fill="#8E53F7" />
      </svg>

      <p style={textStyle}>{text}</p>
    </div>
  );
};

export default TemplateWarningBanner;
